import React from 'react';
import styled from '@emotion/styled';
import { WithContentSlotSidePaddingContainer } from 'ds/components/Layout';

const BasicRendererWrapper = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-family: NovemberHebrew;

  p {
    padding: 0 0 40px;
  }

  h2 {
    font-size: 21px;
    font-family: NovemberHebrew;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.58;
    font-weight: 600;
  }

  h3 {
    font-size: 17px;
    font-family: NovemberHebrew;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.58;
    font-weight: 600;
  }

  h4 {
    font-size: 13px;
    font-family: NovemberHebrew;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.58;
    font-weight: 600;
    text-transform: uppecase;
  }

  ul {
    list-style-type: disc;
  }

  ul, ol {
    padding: 0 0 40px;
    li {
      margin: 0 0 16px 16px;
    }
  }

  b, strong {
    font-weight: 600;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.brand.main};
    &:hover {
      color: ${({ theme }) => theme.colors.brand.dark};
    }
    &:active {
      color: ${({ theme }) => theme.colors.brand.darker};
    }
  }
`;

export const BasicRenderer: React.FunctionComponent<{ content: string }> = ({ content }) => {
  return (
    <BasicRendererWrapper>
      <WithContentSlotSidePaddingContainer>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </WithContentSlotSidePaddingContainer>
    </BasicRendererWrapper>
  );
};
